'use client';
import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navLinks = [
    { title: 'Služby', href: '#services' },
    { title: 'Portfolio', href: '#portfolio' },
    { title: 'O nás', href: '#about' },
    { title: 'Kontakt', href: '#contact' },
  ];

  // Base classes that are always present for the glass effect
  const navContainerBaseClasses =
    'p-4 rounded-2xl backdrop-blur-xl transition-colors duration-500';

  // Classes that change on scroll  
  const navContainerScrollClasses = hasScrolled
    ? 'bg-black/50'
    : 'bg-transparent';

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 py-4">
      <div className="container mx-auto px-6">
        <div className={`
          ${navContainerBaseClasses} 
          ${navContainerScrollClasses}
          transition-all duration-300 ease-out
          max-h-screen overflow-hidden
        `}>
          {/* Main navbar content */}
          <div className="flex justify-between items-center">
            <a href="#" className="text-2xl font-bold text-white hover:text-indigo-400 transition-colors duration-300">
              Δ DeltaWeb
            </a>
            <div className="hidden md:flex space-x-8 items-center">
              {navLinks.map((link) => (
                <a
                  key={link.title}
                  href={link.href}
                  className="text-slate-300 hover:text-white transition-colors duration-300 relative group"
                >
                  {link.title}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-indigo-500 to-purple-500 group-hover:w-full transition-all duration-300"></span>
                </a>
              ))}
            </div>
            <div className="md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-white focus:outline-none transition-transform duration-200 hover:scale-110"
              >
                {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
              </button>
            </div>
          </div>
          
          {/* Expandable mobile menu - same container */}
          <div className={`
            md:hidden overflow-hidden transition-all duration-300 ease-out
            ${
              isOpen 
                ? 'max-h-80 mt-4 pt-4 opacity-100' 
                : 'max-h-0 mt-0 pt-0 opacity-0'
            }
            border-t border-white/20
          `}>
            <div className="space-y-1">
              {navLinks.map((link) => (
                <a
                  key={link.title}
                  href={link.href}
                  onClick={() => setIsOpen(false)}
                  className="block text-slate-300 hover:text-white transition-colors duration-200 py-3 px-2 text-base hover:bg-white/5 rounded-lg"
                >
                  {link.title}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;